export default __webpack_public_path__ + "static/media/Nunito-Regular.f400658b.eot";